import { Message } from 'element-ui'

export default Message
